import { useEffect } from 'react';

export const useSearchAndFocusHotkey = (
  inputReference: React.RefObject<HTMLInputElement | null>,
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        // macos
        (event.metaKey && event.key === 'f') ||
        // windows
        (event.ctrlKey && event.key === 'f')
      ) {
        event.preventDefault();
        inputReference.current?.setSelectionRange(
          0,
          inputReference.current?.value.length,
        );
        inputReference.current?.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [inputReference]);
};
